// iPhone Safari 向けカメラ操作

let stream = null;
let facingMode = 'environment';

export async function startCamera(videoEl) {
  await stopCamera();
  try {
    stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: { ideal: facingMode },
        width: { ideal: 1920 },
        height: { ideal: 1080 },
      },
      audio: false,
    });
  } catch (err) {
    if (err && err.name === 'OverconstrainedError') {
      stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
    } else {
      throw err;
    }
  }
  videoEl.srcObject = stream;
  await videoEl.play().catch(() => {});
}

export async function stopCamera() {
  if (stream) {
    for (const track of stream.getTracks()) track.stop();
    stream = null;
  }
}

export async function flipCamera(videoEl) {
  facingMode = facingMode === 'environment' ? 'user' : 'environment';
  await startCamera(videoEl);
}

// videoの現在フレームを長辺最大1600pxにリサイズしてJPEG Blobで返す
export function captureFrame(videoEl, canvasEl) {
  const w = videoEl.videoWidth;
  const h = videoEl.videoHeight;
  if (!w || !h) throw new Error('video stream not ready');

  const MAX = 1600;
  const scale = Math.min(1, MAX / Math.max(w, h));
  const cw = Math.round(w * scale);
  const ch = Math.round(h * scale);

  canvasEl.width = cw;
  canvasEl.height = ch;
  const ctx = canvasEl.getContext('2d');
  ctx.drawImage(videoEl, 0, 0, cw, ch);

  return new Promise((resolve, reject) => {
    canvasEl.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error('capture failed'))),
      'image/jpeg',
      0.85
    );
  });
}

export async function blobToDataURL(blob) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = () => reject(r.error);
    r.readAsDataURL(blob);
  });
}
